/*********************** Custom JS for Boost AI Search & Discovery  ************************/
// window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
//   (componentRegistry) => {
//         componentRegistry.useComponentPlugin('ProductList', {
//             name: 'Custom Product List',
//             enabled: true,
//             apply: () => ({
//               afterRender(element) {
//                 try {
//                   // Start customization--------------------------------------------
//                   var fragment = document.querySelector('.boost-sd-right .boost-sd__toolbar-container');
//                   document.querySelector('.boost-sd-left').insertAdjacentElement('afterBegin',fragment);
//                 } catch (e) {
//                   console.error(e);
//                 }
//               }
//             })
//         });
//     }
// ]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("PaginationPageLink", {
      name: "Modify Component FormatCurrency",
      enabled: true,
      apply: () => ({
        props: (props, element) => {
          // props.label += ' Boost';

          console.log(props);
          return props;
        },
        afterRender(element) {
          try {
            const props = element.getParams().props;
            // console.log(props, productData)
            // Start-#230599
            const previousPageBtn = document.querySelector(
              ".boost-sd__pagination-button--prev"
            );
            if (previousPageBtn !== null) {
              previousPageBtn.setAttribute(
                "href",
                previousPageBtn.getAttribute("href").replaceAll("?page=1", "")
              );
            }
            // End-#230599
          } catch (e) {
            console.warn(e);
          }
        },
      }),
    });
  },
]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat(
  (registry) => {
    //   registry.useComponentPlugin('PaginationNumber', {
    //     name: 'Change PaginationNumber to anchor tag',
    //     enabled: true,
    //     apply: () => ({
    //       afterRender:(element)=>{
    //         const anchorTag = document.createElement('a');
    //         const {page, disabled, active} = element.getParams().props;
    //         const currentUrl = new URL(window.location);
    //         currentUrl.searchParams.set('page', page)
    //         anchorTag.href = currentUrl.href.replace('?page=1','');
    //         anchorTag.innerHTML = page;
    //         anchorTag.className = `boost-sd__pagination-number boost-sd__pagination-number--square ${active?'boost-sd__pagination-number--active':''} ${disabled?'boost-sd__pagination-number--disabled':''}`
    //         element.getRootElm().replaceWith(anchorTag)
    //       }
    //     }),
    // });
    //   registry.useComponentPlugin('PaginationPageLink', {
    //     name: 'Change Prev and Next button to anchor tag',
    //     enabled: true,
    //     apply: () => ({
    //       props:(props)=>{
    //         if(props.prevButton){
    //           props.onPrevButtonRender = () => {
    //             const anchorTag = document.createElement('a');
    //             const currentUrl = new URL(window.location);
    //             currentUrl.searchParams.set('page', props.currentPage - 1)
    //             anchorTag.href = currentUrl.href;
    //             anchorTag.innerHTML = `<div class="boost-sd__pagination-button-icon boost-sd__pagination-button-icon--left"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 7 12" height="12" width="7"><path d="M6.80474 0.528514C6.54439 0.268165 6.12228 0.268165 5.86193 0.528514L0.861929 5.52851C0.601579 5.78886 0.601579 6.21097 0.861929 6.47132L5.86193 11.4713C6.12228 11.7317 6.54439 11.7317 6.80474 11.4713C7.06509 11.211 7.06509 10.7889 6.80474 10.5285L2.27614 5.99992L6.80474 1.47132C7.06509 1.21097 7.06509 0.788864 6.80474 0.528514Z" clip-rule="evenodd" fill-rule="evenodd"></path></svg></div>`;
    //             anchorTag.className = `boost-sd__pagination-button boost-sd__pagination-button--square boost-sd__pagination-button--prev`;
    //             return anchorTag
    //           }
    //         }
    //         if(props.nextButton){
    //           props.onNextButtonRender = () => {
    //             const anchorTag = document.createElement('a');
    //             const currentUrl = new URL(window.location);
    //             currentUrl.searchParams.set('page', props.currentPage + 1)
    //             anchorTag.href = currentUrl.href;
    //             anchorTag.innerHTML = `<div class="boost-sd__pagination-button-icon boost-sd__pagination-button-icon--right"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 7 12" height="12" width="7"><path d="M0.195262 0.528514C0.455612 0.268165 0.877722 0.268165 1.13807 0.528514L6.13807 5.52851C6.39842 5.78886 6.39842 6.21097 6.13807 6.47132L1.13807 11.4713C0.877722 11.7317 0.455612 11.7317 0.195262 11.4713C-0.0650874 11.211 -0.0650874 10.7889 0.195262 10.5285L4.72386 5.99992L0.195262 1.47132C-0.0650874 1.21097 -0.0650874 0.788864 0.195262 0.528514Z" clip-rule="evenodd" fill-rule="evenodd"></path></svg></div>`;
    //             anchorTag.className = `boost-sd__pagination-button boost-sd__pagination-button--square boost-sd__pagination-button--next`;
    //             return anchorTag
    //           }
    //         }
    //         return props;
    //       }
    //     })
    // });
  }
);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductItemWidget", {
      name: "Add Custom Labels to ProductItemWidget ",
      enabled: true,
      apply: () => ({
        props: (props, element) => {
          return props;
        },
        afterRender(element) {
          try {
            const { product } = element.getParams().props;

            let vapecycle = false;
            let subscription = false;
            let customTagHTML = '';
            let swapAvailable;

            let subscribeLink = theme.settings.subscribe_link;
            let vapecycleLink = theme.settings.vape_cycle_link;

            const sbSvgUrl = theme.settings.sb_svg;
            const vapeCycleSvgUrl = theme.settings.vape_cycle_svg;
            console.log('product.tags', product.tags);
            if (product.tags) {
              product.tags.forEach((tag) => {
                if (tag === "VapeCycle") {
                  vapecycle = true;
                }
                if (tag === "subscriptions") {
                  subscription = true;
                }
                if (tag.toLowerCase() === "swap-available") {
                  swapAvailable = true;
                }
              });
            }

            if (vapecycle || subscription) {
              if (subscription && typeof subscribeLink !== "undefined") {
                customTagHTML += `
                  <div class="subscription--wrap">
                    <a href="${subscribeLink}">
                      <img src="${sbSvgUrl}" alt="Subscription" loading="lazy">
                    </a>
                  </div>`;
              }
              if (vapecycle && typeof vapecycleLink !== "undefined") {
                customTagHTML += `
                  <div class="vapcycle--wrap">
                    <a href="${vapecycleLink}">
                      <img src="${vapeCycleSvgUrl}" alt="VapeCycle" loading="lazy">
                    </a>
                  </div>`;
              }
              console.log("swapAvailable", swapAvailable);
              if (swapAvailable) {
                customTagHTML += `
                  <div class="vapcycle--wrap swap-badge">
                    <a href="${theme.settings.swap_available_link || "https://www.vapo.co.nz/collections/prefilled-pods"}">
                      <img width="50" src="${theme.settings.swap_available_image || 'https://www.vapo.co.nz/cdn/shop/files/available-in-pod_small.svg?v=1739503531'}" alt="VapeCycle" loading="lazy">
                    </a>
                  </div>`;
              }

            }

            const productCard = element.getRootElm();
            const imageContainer = productCard.querySelector(
              ".boost-sd__product-item-grid-view-layout-image"
            );

            if (imageContainer) {
              let existingBadgesWrap =
                imageContainer.querySelector(".badges-wrap");

              if (existingBadgesWrap) {
                existingBadgesWrap.innerHTML = customTagHTML;
              } else {
                const badgesWrap = document.createElement("div");
                badgesWrap.className = "badges-wrap";
                badgesWrap.innerHTML = customTagHTML;
                imageContainer.appendChild(badgesWrap);
              }
            }
          } catch (e) {
            console.warn(e);
          }
        },
      }),
    });
  },
]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductItem", {
      name: "Add Custom Labels to ProductItem ",
      enabled: true,
      apply: () => ({
        props: (props, element) => {
          return props;
        },
        afterRender(element) {
          try {
            const { product } = element.getParams().props;

            let boostTagHTML = "";
            if (product.tags) {
              product.tags.forEach((tag) => {
                if (tag.startsWith("pfs:label-")) {
                  let labelName = tag.replace("pfs:label-", "");
                  let labelClass = labelName.toLowerCase().replace(/\s+/g, "-");

                  boostTagHTML += `
                      <div class="boost-sd__product-label boost-sd__product-label--rectangle boost-sd__suggestion-queries-item-badge--${labelClass}">
                        <span class="boost-sd__product-label-text">${labelName}</span>
                      </div>`;

                  if (
                    labelName.includes("coming") ||
                    labelName.includes("comming")
                  ) {
                    // hide all sold out badges
                    element
                      .getRootElm()
                      .querySelectorAll(".boost-sd__product-label--soldout")
                      .forEach((badge) => {
                        badge.style.display = "none";
                      });
                  }
                }
              });
            }

            const productCard = element.getRootElm();
            const imageContainer = productCard.querySelector(
              ".boost-sd__product-image-column.boost-sd__product-image-column--in-top"
            );
            //const badgeNodes = productCard.querySelectorAll('.boost-sd__suggestion-queries-item-badge');

            if (imageContainer && boostTagHTML) {
              let existingBadgesWrap = imageContainer.querySelector(
                ".badges-search-wrap"
              );

              const badgesWrap = document.createElement("div");
              badgesWrap.innerHTML = boostTagHTML;

              // loop all childs badgesWrap and append to imageContainer

              if (!imageContainer.classList.contains("badges-added")) {
                imageContainer.innerHTML =
                  imageContainer.innerHTML + boostTagHTML;
                imageContainer.classList.add("badges-added");
              }
            }

            //move all badgeNodes to badgesWrap

            // if (badgeNodes.length > 0) {
            //   const badgesWrap = productCard.querySelector('.badges-search-wrap');
            //   badgeNodes.forEach((badgeNode) => {
            //     badgesWrap.appendChild(badgeNode);
            //   });
            // }
          } catch (e) {
            console.warn(e);
          }
        },
      }),
    });
  },
]);
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("SearchProductItem", {
      name: "Add Custom Labels to SearchProductItem ",
      enabled: true,
      apply: () => ({
        props: (props, element) => {
          return props;
        },
        afterRender(element) {
          try {
            const { product } = element.getParams().props;

            let boostTagHTML = "";
            if (product.tags) {
              product.tags.forEach((tag) => {
                if (tag.startsWith("pfs:label-")) {
                  let labelName = tag.replace("pfs:label-", "");
                  let labelClass = labelName.toLowerCase().replace(/\s+/g, "-");

                  boostTagHTML += `
                    <div class="boost-sd__suggestion-queries-item-badge boost-sd__suggestion-queries-item-badge--${labelClass}">
                      <span>${labelName}</span>
                    </div>`;

                  if (
                    labelName.includes("coming") ||
                    labelName.includes("comming")
                  ) {
                    // hide all sold out badges
                    element
                      .getRootElm()
                      .querySelectorAll(
                        ".boost-sd__suggestion-queries-item-badge--sold-out"
                      )
                      .forEach((badge) => {
                        badge.style.display = "none";
                      });
                  }
                }
              });
            }

            const productCard = element.getRootElm();
            const imageContainer = productCard.querySelector(
              ".boost-sd__suggestion-queries-item-product.boost-sd__suggestion-queries-item-product--left"
            );
            const badgeNodes = productCard.querySelectorAll(
              ".boost-sd__suggestion-queries-item-badge"
            );

            if (imageContainer && boostTagHTML) {
              let existingBadgesWrap = imageContainer.querySelector(
                ".badges-search-wrap"
              );

              if (existingBadgesWrap) {
                existingBadgesWrap.innerHTML = boostTagHTML;
              } else {
                const badgesWrap = document.createElement("div");
                badgesWrap.className = "badges-search-wrap";
                badgesWrap.innerHTML = boostTagHTML;
                imageContainer.appendChild(badgesWrap);
              }
            }

            //move all badgeNodes to badgesWrap

            if (badgeNodes.length > 0) {
              const badgesWrap = productCard.querySelector(
                ".badges-search-wrap"
              );
              badgeNodes.forEach((badgeNode) => {
                badgesWrap.appendChild(badgeNode);
              });
            }
          } catch (e) {
            console.warn(e);
          }
        },
      }),
    });
  },
]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("PaginationPageLink", {
      name: "Modify Component FormatCurrency",
      enabled: true,
      apply: () => ({
        props: (props, element) => {
          // props.label += ' Boost';

          console.log(props);
          return props;
        },
        afterRender(element) {
          try {
            const props = element.getParams().props;
            // console.log(props, productData)
            // Start-#230599
            const previousPageBtn = document.querySelector(
              ".boost-sd__pagination-button--prev"
            );
            if (previousPageBtn !== null) {
              previousPageBtn.setAttribute(
                "href",
                previousPageBtn.getAttribute("href").replaceAll("?page=1", "")
              );
            }
            // End-#230599
          } catch (e) {
            console.warn(e);
          }
        },
      }),
    });
  },
]);

// window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
//     registry.useComponentPlugin('PaginationNumber', {
//       name: 'Change PaginationNumber to anchor tag',
//       enabled: true,
//       apply: () => ({
//         afterRender:(element)=>{
//           const anchorTag = document.createElement('a');
//           const {page, disabled, active} = element.getParams().props;
//           const currentUrl = new URL(window.location);
//           currentUrl.searchParams.set('page', page)
//           anchorTag.href = currentUrl.href.replace('?page=1','');
//           anchorTag.innerHTML = page;
//           anchorTag.className = `boost-sd__pagination-number boost-sd__pagination-number--square ${active?'boost-sd__pagination-number--active':''} ${disabled?'boost-sd__pagination-number--disabled':''}`

//           element.getRootElm().replaceWith(anchorTag)
//         }
//       }),
//   });

//   registry.useComponentPlugin('PaginationPageLink', {
//     name: 'Change Prev and Next button to anchor tag',
//     enabled: true,
//     apply: () => ({
//       props:(props)=>{
//         if(props.prevButton){
//           props.onPrevButtonRender = () => {
//             const anchorTag = document.createElement('a');
//             const currentUrl = new URL(window.location);
//             currentUrl.searchParams.set('page', props.currentPage - 1)
//             anchorTag.href = currentUrl.href;
//             anchorTag.innerHTML = `<div class="boost-sd__pagination-button-icon boost-sd__pagination-button-icon--left"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 7 12" height="12" width="7"><path d="M6.80474 0.528514C6.54439 0.268165 6.12228 0.268165 5.86193 0.528514L0.861929 5.52851C0.601579 5.78886 0.601579 6.21097 0.861929 6.47132L5.86193 11.4713C6.12228 11.7317 6.54439 11.7317 6.80474 11.4713C7.06509 11.211 7.06509 10.7889 6.80474 10.5285L2.27614 5.99992L6.80474 1.47132C7.06509 1.21097 7.06509 0.788864 6.80474 0.528514Z" clip-rule="evenodd" fill-rule="evenodd"></path></svg></div>`;
//             anchorTag.className = `boost-sd__pagination-button boost-sd__pagination-button--square boost-sd__pagination-button--prev`;
//             return anchorTag
//           }
//         }
//         if(props.nextButton){
//           props.onNextButtonRender = () => {
//             const anchorTag = document.createElement('a');
//             const currentUrl = new URL(window.location);
//             currentUrl.searchParams.set('page', props.currentPage + 1)
//             anchorTag.href = currentUrl.href;
//             anchorTag.innerHTML = `<div class="boost-sd__pagination-button-icon boost-sd__pagination-button-icon--right"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 7 12" height="12" width="7"><path d="M0.195262 0.528514C0.455612 0.268165 0.877722 0.268165 1.13807 0.528514L6.13807 5.52851C6.39842 5.78886 6.39842 6.21097 6.13807 6.47132L1.13807 11.4713C0.877722 11.7317 0.455612 11.7317 0.195262 11.4713C-0.0650874 11.211 -0.0650874 10.7889 0.195262 10.5285L4.72386 5.99992L0.195262 1.47132C-0.0650874 1.21097 -0.0650874 0.788864 0.195262 0.528514Z" clip-rule="evenodd" fill-rule="evenodd"></path></svg></div>`;
//             anchorTag.className = `boost-sd__pagination-button boost-sd__pagination-button--square boost-sd__pagination-button--next`;
//             return anchorTag
//           }
//         }
//         return props;
//       }
//     })
// });
// });
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("PaginationNumber", {
      name: "add tag a to button PaginationNumber",
      apply: () => ({
        afterRender: (element) => {
          try {
            let page = element?.getParams()?.props?.page;
            const href = `${location.origin}${location.pathname}?page=${page}`;

            element.getRootElm().innerHTML = `<a style="display: none;" href="${href}">${page}</a>${page}`;
          } catch (error) {
            console.warning(error);
          }
        },
      }),
    });
  },
]);

const customize = {
  updateProductItemGrid: (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductItem", {
      name: "Add extra information",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            // Start customization--------------------------------------------
            let productData = element.getParams().props.product;
            let isOnlyHaveDefaultVariant = productData.variants.length === 1;
            let productId = productData.id;
            if (productData?.split_product) {
              productId = productData.variant_id;
            }
            let productItem = document.querySelector(
              '[data-product-id="' + productId + '"]'
            );
            let productOption = productItem.querySelector(".variations");
            if (productItem && !productOption) {
              console.log(productData);
              let html = `
            `;
              var wrapper = document.createElement("variant-selects");
              wrapper.classList.add("variations");

              productData.options_with_values.forEach((option, i) => {
                html += `
                  <fieldset class="product-form__input product-form__input--block radio radio-toolbar" data-option="${option.label.toLowerCase()}">
                    <div class="form__label">${
                      option.label
                    }: <span class="form__label__value">${
                  option.values[0].title
                }</span></div>
                                                ${option.values
                                                  .map((value, index) => {
                                                    return `
                          <input type="radio" id="${option.label}-${index}"
                                name="${option.label}" value="${value.title}" ${
                                                      index === 0
                                                        ? 'checked="checked"'
                                                        : ""
                                                    } 
                          >
                          <label for="${option.label}-${index}">
                            <span>${value.title}</span>
                          </label>
                        `;
                                                  })
                                                  .join("")}
                    <script type="application/json">
                        ${JSON.stringify(productData.variants)}
                    </script>
                  </fieldset>

              `;
              });

              html += `
            <product-form>
                <div class="product-form__error-message-wrapper form-notification error" role="alert" hidden>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="9" cy="9" r="9" fill="#E93636"/>
                  <path d="M9 5V9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 13C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13Z" fill="white"/>
                  </svg>
                  <span class="product-form__error-message"></span>
                </div>
              <form method="post" action="/cart/add"
                  accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate"
                  data-type="add-to-cart-form">
                  <div class="bold_options bold_options_loaded"></div>
                  <div class="ro_widget"></div>
                  <div class="bold-bundles-product bold_bundles_product_loaded"></div><input type="hidden" name="form_type"
                      value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id"
                      value="${productData.variants[0].id}">
                  <div class="product-add-to-cart-container">
                      <div class="form-notification error" style="display:none;"></div>
                      <div class="add_to_cart_holder"><span class="bold-ro__widget-loading" data-widget-loading=""
                              style="display:none"><span class="bold-ro__loading-container">
                                  <style>
                                      .bold-ro__widget-loading {
                                          margin-left: 45%;
                                      }

                                      .bold-ro__widget-loading-icon {
                                          border: 10px solid #f3f3f3;
                                          border-radius: 50%;
                                          border-top: 10px solid #3498db;
                                          width: 50px;
                                          height: 50px;
                                          -webkit-animation: spin 2s linear infinite;
                                          animation: spin 2s linear infinite;
                                          margin-bottom: 20px;
                                      }
                                  </style>
                                  <div data-bold-widget-loading-icon="" class="bold-ro__widget-loading-icon"></div>
                              </span></span><button class="btn button bold-ro__custombutton-7407914156171"
                              style="display: none;">ADD TO CART</button><button type="submit" name="add" id="AddToCart"
                              class="single-add-to-cart-button button cartbutton ${
                                productData.available ? "" : "sold-out"
                              }" ${
                productData.available ? "" : "disabled"
              } style="visibility: visible;">
                              <span class="single-add-to-cart-button--text" wz-last-el-ref="true">
                              ${
                                productData.available
                                  ? "Add to cart"
                                  : "Sold out"
                              }
                              </span>
                              <span class="single-add-to-cart-button--text hidden sold-out-text" wz-last-el-ref="true">
                              Sold out
                              </span>
                              <span class="loading-overlay">

                                  <svg aria-hidden="true" focusable="false" role="presentation" class="spinner"
                                      viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                      <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30"
                                          stroke="var(--color-accent)"></circle>
                                  </svg>

                              </span>
                          </button></div>
                  </div><input type="hidden" name="product-id" value="7407914156171"><input type="hidden" name="section-id"
                      value="template--16580346478731__main-product">
              </form>
          </product-form>

            `;

              const bagQuickAddMobile = `
              <!-- <div class="quick-bag-add-mobile">
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.13135 2.9771L2.95222 0.714667V0.650024H10.1101L11.8682 2.9771M1.13135 2.9771V11.1865C1.13135 11.8329 1.69645 12.35 2.32433 12.35H10.6752C11.3031 12.35 11.8682 11.8329 11.8682 11.1865V2.9771M1.13135 2.9771H11.8682M8.91714 5.30417C8.91714 6.597 7.84971 7.63122 6.53116 7.63122C5.2126 7.63122 4.08241 6.597 4.08241 5.30417" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>


                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="12" height="12" rx="6" fill="black"/>
                <path d="M2.962 6.3V5.376H5.496V2.968H6.504V5.376H9.038V6.3H6.504V8.708H5.496V6.3H2.962Z" fill="white"/>
                </svg>

              </div>
              -->
                                  <product-form>
                <div class="product-form__error-message-wrapper form-notification error" role="alert" hidden>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="9" cy="9" r="9" fill="#E93636"/>
                  <path d="M9 5V9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 13C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13Z" fill="white"/>
                  </svg>
                  <span class="product-form__error-message"></span>
                </div>
              <form method="post" action="/cart/add"
                  accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate"
                  data-type="add-to-cart-form">
                  <div class="bold_options bold_options_loaded"></div>
                  <div class="ro_widget"></div>
                  <div class="bold-bundles-product bold_bundles_product_loaded"></div><input type="hidden" name="form_type"
                      value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id"
                      value="${productData.variants[0].id}">
                  <div class="product-add-to-cart-container">
                      <div class="form-notification error" style="display:none;"></div>
                      <div class="add_to_cart_holder"><span class="bold-ro__widget-loading" data-widget-loading=""
                              style="display:none"><span class="bold-ro__loading-container">
                                  <style>
                                      .bold-ro__widget-loading {
                                          margin-left: 45%;
                                      }

                                      .bold-ro__widget-loading-icon {
                                          border: 10px solid #f3f3f3;
                                          border-radius: 50%;
                                          border-top: 10px solid #3498db;
                                          width: 50px;
                                          height: 50px;
                                          -webkit-animation: spin 2s linear infinite;
                                          animation: spin 2s linear infinite;
                                          margin-bottom: 20px;
                                      }
                                  </style>
                                  <div data-bold-widget-loading-icon="" class="bold-ro__widget-loading-icon"></div>
                              </span></span><button class="btn button bold-ro__custombutton-7407914156171"
                              style="display: none;">ADD TO CART</button><button type="submit" name="add" id="AddToCart"
                              class="single-add-to-cart-button button cartbutton ${
                                productData.available ? "" : "sold-out"
                              }" ${
                productData.available ? "" : "disabled"
              } style="visibility: visible;">
                              <span class="single-add-to-cart-button--text" wz-last-el-ref="true">
                              ${
                                productData.available
                                  ? isOnlyHaveDefaultVariant
                                    ? "Add to cart"
                                    : "Choose Options"
                                  : "Sold out"
                              }
                              </span>
                              <span class="single-add-to-cart-button--text hidden sold-out-text" wz-last-el-ref="true">
                              Sold out
                              </span>
                              <span class="loading-overlay">

                                  <svg aria-hidden="true" focusable="false" role="presentation" class="spinner"
                                      viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                      <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30"
                                          stroke="var(--color-accent)"></circle>
                                  </svg>

                              </span>
                          </button></div>
                  </div><input type="hidden" name="product-id" value="7407914156171"><input type="hidden" name="section-id"
                      value="template--16580346478731__main-product">
              </form>
          </product-form>
            `;

              var bagDiv = document.createElement("div");
              bagDiv.classList.add("bag-quick-add");
              bagDiv.innerHTML = bagQuickAddMobile;

              if (!isOnlyHaveDefaultVariant) {
                bagDiv.addEventListener("click", function (e) {
                  e.preventDefault();
                  e.stopPropagation();

                  const variantSelect = wrapper;

                  const cloneNode = variantSelect.cloneNode(true);

                  const overlayPopup =
                    document.getElementById("quick-add-overlay");

                  const container =
                    overlayPopup.querySelector(".container-overlay");

                  container.innerHTML = "";

                  // append -mobile for any id of input radio button of clone node
                  cloneNode
                    .querySelectorAll('input[type="radio"]')
                    .forEach((input) => {
                      input.id = input.id + "-mobile";
                      input.name = input.name + "-mobile";
                    });

                  // append -mobile for any id of label of radio button of clone node
                  cloneNode
                    .querySelectorAll('input[type="radio"] + label')
                    .forEach((label) => {
                      label.htmlFor = label.htmlFor + "-mobile";
                    });

                  container.appendChild(cloneNode);

                  window.on();

                  document
                    .querySelectorAll(
                      '.radio-toolbar input[type="radio"]:nth-of-type(1)'
                    )
                    .forEach((input) => {
                      input.checked = true;
                    });
                });
              }

              if (productData.available) {
                productItem
                  .querySelector(".boost-sd__product-info")
                  .appendChild(bagDiv);

                wrapper.innerHTML = html;
                productItem
                  .querySelector(
                    ".boost-sd__product-item-grid-view-layout-image"
                  )
                  .appendChild(wrapper);
              }
            }
            // End-------------------------------------------------------------
          } catch (e) {
            console.warn(e);
          }
        },
      }),
    });
  },
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.updateProductItemGrid,
]);
